import React from "react";
import styles from "./styles/NavButton.module.css";
import { NavLink } from "react-router-dom";
/**
 * Navigation button component
 */
const NavButton = ({ body, size, link, newWindow, fullWidth, fromApp }) => {
    return (
        <NavLink
            className={`${
                size === "adapt"
                    ? styles.adapt
                    : size === "small"
                    ? styles.small
                    : styles.standard
            } ${styles.nav_button} display-flex`}
            style={{
                width: fullWidth ? "100%" : "unset",
            }}
            to={link}
            state={{ fromApp: fromApp }}
            aria-label={`link to ${body}`}
            target={newWindow ? "_blank" : ""}
            rel={newWindow ? "noreferrer" : ""}
        >
            {body}
        </NavLink>
    );
};

export default NavButton;
